export default __webpack_public_path__ + "static/familia-f167d439c2fbd6f2f16d61a8503a5b2c.png";